import { Component } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { Params, Data, ActivatedRoute } from '@angular/router';
import { DynamicFormContent } from 'src/app/services/application-resources/models/page-resource-content';
import { tap } from 'rxjs/operators';
import { getDataUrl } from 'src/app/helpers/get-data-url';
import { SelectEditField } from 'src/app/components/edit-form/models/edit-fields';

@Component({
    selector: 'app-dynamic-form-page',
    templateUrl: './dynamic-form-page.component.html',
    standalone: false
})
export class DynamicFormPageComponent {
  private routeParams$: Observable<Params>;
  private queryParams$: Observable<Params>;
  private routeData$: Observable<Data>;

  public onInit$: Observable<[Params, Params, Data]>;
  constructor(private route: ActivatedRoute) {
    this.routeParams$ = this.route.params;
    this.queryParams$ = this.route.queryParams;
    this.routeData$ = this.route.data;

    this.onInit$ = combineLatest([
      this.routeParams$,
      this.queryParams$,
      this.routeData$,
    ]).pipe(tap((options) => this.initialize(options)));
  }

  dynamicFormContent: DynamicFormContent;

  private initialize(options: [Params, Params, Data]) {
    const [routeParams, queryParams, routeData] = options;
    this.dynamicFormContent = routeData as DynamicFormContent;

    let parameters: Params = {};
    Object.assign(parameters, routeParams);
    Object.assign(parameters, queryParams);

    if (this.dynamicFormContent.getFormUrl)
      this.dynamicFormContent.getFormUrl = getDataUrl(parameters, this.dynamicFormContent.getFormUrl);

    if (this.dynamicFormContent.saveFormUrl)
      this.dynamicFormContent.saveFormUrl = getDataUrl( parameters, this.dynamicFormContent.saveFormUrl);

      this.dynamicFormContent.fields.forEach(field => {
        const selectField = field as SelectEditField;
        if(selectField?.optionsUrl) {
          const modifiedOptionsUrl = getDataUrl(parameters, selectField.optionsUrl);
          selectField.optionsUrl = modifiedOptionsUrl;
        }
      })
  }
}
